import { render } from "./VistaCentros.vue?vue&type=template&id=a946b028&scoped=true"
import script from "./VistaCentros.vue?vue&type=script&lang=js"
export * from "./VistaCentros.vue?vue&type=script&lang=js"

import "./VistaCentros.vue?vue&type=style&index=0&id=a946b028&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a946b028"]])

export default __exports__